import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type CellType = {
  dataField: string;
  text: string;
  sort: boolean;
};

export const boldFormatter = (cell: any, row: any) => {
  return <span style={{ fontWeight: 600, fontSize: "18px" }}>{cell}</span>;
};

export const lockIfFalseFormatter = (cell: any, row: any) => {
  if (cell === false) {
    return (
      <span>
        <FontAwesomeIcon style={{ color: "red" }} icon={["fal", "lock-alt"]} />
      </span>
    );
  } else {
    return (
      <span>
        <FontAwesomeIcon
          style={{ color: "green" }}
          icon={["fal", "lock-open-alt"]}
        />
      </span>
    );
  }
};

export const hideIfTrueFormatter = (cell: any, row: any) => {
  if (cell) {
    return (
      <span>
        <FontAwesomeIcon style={{ color: "red" }} icon={["fal", "eye-slash"]} />
      </span>
    );
  } else {
    return (
      <span>
        <FontAwesomeIcon style={{ color: "green" }} icon={["fal", "eye"]} />
      </span>
    );
  }
};

export const xIfTrueFormatter = (cell: any, row: any) => {
  if (cell) {
    return (
      <span>
        <FontAwesomeIcon style={{ color: "red" }} icon={["fal", "times"]} />
      </span>
    );
  } else {
    return (
      <span>
        <FontAwesomeIcon style={{ color: "green" }} icon={["fal", "check"]} />
      </span>
    );
  }
};

export const xIfFalseFormatter = (cell: any, row: any) => {
  if (!cell) {
    return (
      <span>
        <FontAwesomeIcon style={{ color: "red" }} icon={["fal", "times"]} />
      </span>
    );
  } else {
    return (
      <span>
        <FontAwesomeIcon style={{ color: "green" }} icon={["fal", "check"]} />
      </span>
    );
  }
};

export const handleDescription = (cell: any, row: any) => {
  if (row.description === "") {
    return <span style={{ fontStyle: "italic" }}>No description</span>;
  }
  return <span>{cell}</span>;
};

export const parseTimestamp = (cell: any, row: any) => {
  if (cell) {
    const date = new Date(parseInt(cell));
    const dateString = date.toUTCString();
    return <span>{`${dateString}`}</span>;
  }
  return <span>-</span>;
};

export const options = {
  sizePerPage: 10,
  paginationSize: 4,
  pageStartIndex: 1,
  hideSizePerPage: true, // Hide the dropdown for modifying the shown items
  withFirstAndLast: false, // Hide the going to First and Last page button
  hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
  firstPageText: "First",
  prePageText: "<",
  nextPageText: ">",
  lastPageText: "Last",
  nextPageTitle: "First page",
  prePageTitle: "Prev page",
  firstPageTitle: "Next page",
  lastPageTitle: "Last page",
  sizePerPageList: [
    {
      text: "Show 5",
      value: 5
    },
    {
      text: "Show 10",
      value: 10
    },
    {
      text: "Show 20",
      value: 20
    }
  ]
};
